import { useIntl } from "react-intl";

import type { FlightFormLocation } from "@/types/types";

type LocationNameProps = {
  location: FlightFormLocation;
};

export function LocationName({ location }: LocationNameProps) {
  const intl = useIntl();

  return (
    <>
      {location.name}

      {location.type === "CITY" && (
        <>
          <span className="mx-1 text-stroke-neutral-medium">&bull;</span>
          {intl.formatMessage({ id: "flights.search.allAirports" })}
        </>
      )}
    </>
  );
}
